<template>
  <!-- <div style=""></div> -->
  <div class="scheduleMatter">
    <headers
      class="herderNav"
      ref="header"
      :isChange="false"
      :back="1"
      style="position: fixed; width: 100%; top: 0; z-index: 999"
    />
    <div style="height: 60px"></div>
    <div class="matterCard" v-if="mockResult">
      <div class="matterCardTit">答题情况总结</div>
      <div class="matterCardCon">
        <div class="cardConLeft">
          <div class="cardConLeftTit" style="height: 33.33%">
            <div class="leftTitFirst">
              <div class="titFirstDiv">
                <p>Total</p>
                <p>Score</p>
              </div>
              <div class="titFirstTis">{{ mockResult.score }}</div>
            </div>
            <div class="leftTitTwo">
              <p>共用时{{ mockResult.usetime | formatTime }}</p>
            </div>
          </div>
          <div class="cardConLeftCon" style="flex-wrap: wrap; height: 66.66%">
            <div class="conLeftsCon borderRight">
              <div class="leftTitFirst">
                <div class="titFirstDiv titSecondDiv">
                  <p>Quant</p>
                  <p>Score</p>
                </div>
                <div class="titFirstText">{{ mockResult.qscore }}</div>
              </div>
              <div class="leftTitSeconds" style="line-height: 1.5">
                <p>
                  超过了
                  <span style="color: #5191ff; font-weight: bold"
                    >{{ mockResult.qspercentage }}%</span
                  >
                  的考友
                </p>
                <p>共用时 {{ mockResult.qtime | formatTime }}</p>
              </div>
            </div>
            <div class="conLeftsCon">
              <div class="leftTitFirst">
                <div class="titFirstDiv titSecondDiv">
                  <p>Verbal</p>
                  <p>Score</p>
                </div>
                <div class="titFirstText">{{ mockResult.vscore }}</div>
              </div>
              <div class="leftTitSeconds" style="line-height: 1.5">
                <p>
                  超过了
                  <span style="color: #5191ff; font-weight: bold"
                    >{{ mockResult.vspercentage }}%</span
                  >
                  的考友
                </p>
                <p>共用时 {{ mockResult.vtime | formatTime }}</p>
              </div>
            </div>
            <div class="conLeftsCon borderRight xright">
              <div class="leftTitFirst">
                <div class="titFirstDiv titSecondDiv">
                  <p>DI</p>
                  <p>Score</p>
                </div>
                <div class="titFirstText">{{ mockResult.discore }}</div>
              </div>
              <div class="leftTitSeconds" style="line-height: 1.5">
                <p>
                  超过了
                  <span style="color: #5191ff; font-weight: bold"
                    >{{ mockResult.dipercentage }}%</span
                  >
                  的考友
                </p>
                <p>共用时 {{ mockResult.ditime | formatTime }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="cardConRight">
          <img
            :src="
              userinfo.avatar_url === '/static/img/avatar_photo.png'
                ? $headImgUrl
                : userinfo.avatar_url
            "
            alt=""
            style="border-radius: 50%"
          />
          <p>{{ userinfo.nick }}</p>
        </div>
      </div>
    </div>
    <div class="analysis" v-if="mockResult">
      <h2 class="analysisH1">答案解析</h2>
      <div class="switchTab">
        <ul>
          <li
            :class="{ active: curTabIndex === index }"
            v-for="(item, index) in mockResult.topics"
            :key="index"
            @click="switchTab(index)"
          >
            {{ item.part }}
          </li>
        </ul>
      </div>
      <div class="topic_list" v-if="mockResult.topics.length > 0">
        <div
          class="topic_item"
          v-for="(item, index) in mockResult.topics[curTabIndex].topics"
          :key="index"
          @click="switchTopic(item, index)"
          :class="{
            error: item.result === false,
            correct: item.result,
            active: curTopicIndex === index,
          }"
        >
          {{ index + 1 }}
        </div>
      </div>
      <h2 class="analysisH1 analysisNote">题目信息</h2>
      <div class="titleInfo" v-if="curTopicInfo">
        <div
          class="mb20"
          v-html="curTopicInfo.title"
          v-if="curTopicInfo.type != 8"
        ></div>
        <div
          class="rightChoice"
          v-if="curTopicInfo.type == 8 && reasoningList.length != 0"
        >
          <el-tabs v-model="choosed" type="border-card" style="margin: 50px 0">
            <el-tab-pane
              :label="item.reasoning_title"
              :name="index + ''"
              v-for="(item, index) in reasoningList"
              :key="index"
            >
              <div v-html="item.reasoning_content"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div style="height: 40px" v-if="curTopicInfo.type == 8"></div>

        <!-- <div class="mb20" v-html="curTopicInfo.stem.replace(/\n/g, '<br>')"></div> -->
        <div v-if="curTopicInfo.type == 7 && table.length != 0">
          <el-table
            :header-cell-style="{ textAlign: 'center' }"
            :data="table"
            :show-summary="curTopicInfo.table_status == 1"
            :summary-method="getSummaries"
            border
          >
            <template v-if="status">
              <el-table-column
                :prop="item.list.length == 0 ? `name${item.index}` : '0'"
                :label="item.value"
                v-for="(item, index) in tableList"
                :key="index"
                :sortable="item.list.length == 0"
              >
                <template slot="header">
                  <span
                    v-html="
                      item.value.charAt(item.value.length - 2) == '/'
                        ? `${item.value.slice(0, -2)}<sup>${item.value.charAt(
                            item.value.length - 1
                          )}</sup>`
                        : item.value
                    "
                  >
                  </span>
                </template>
                <el-table-column
                  v-if="item.list.length > 0"
                  :prop="`name${v.index}`"
                  :label="v.value"
                  sortable
                  v-for="(v, idx) in item.list"
                  :key="idx"
                >
                  <template slot="header">
                    <span
                      v-html="
                        v.value.charAt(v.value.length - 2) == '/'
                          ? `${v.value.slice(0, -2)}<sup>${v.value.charAt(
                              v.value.length - 1
                            )}</sup>`
                          : v.value
                      "
                    >
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>

            <div v-else v-for="(item, index) in tableList" :key="index">
              <el-table-column
                v-if="item.list.length > 0"
                :prop="index + '-' + idx"
                :label="v"
                sortable
                :fixed="idx == 0"
                v-for="(v, idx) in item.list"
                :key="idx"
              >
                <template slot="header">
                  <span
                    v-html="
                      v.charAt(v.length - 2) == '/'
                        ? `${v.slice(0, -2)}<sup>${v.charAt(
                            v.length - 1
                          )}</sup>`
                        : v
                    "
                  >
                  </span>
                </template>
              </el-table-column>
            </div>
          </el-table>
        </div>
        <div class="mb20" v-html="curTopicInfo.stem"></div>
        <div>
          <div
            class="mb20"
            v-for="(answerItem, index) in curTopicInfo.answer"
            :key="index"
          >
            <div v-if="curTopicInfo.type == 8">
              <div v-if="answerItem.length != 0">
                <!-- {{ index == 0 ? "判断题：" : "单选题：" }} -->
                <div v-for="(xItem, xIndex) in answerItem" :key="xIndex">
                  <span style="margin-right: 10px" v-if="index == 0"
                    >{{ curTopicInfo.yes }} {{ curTopicInfo.no }}</span
                  ><span v-else>
                    {{
                      curTopicInfo.opt[1][xIndex]
                        ? curTopicInfo.opt[1][xIndex] + ". "
                        : ""
                    }} </span
                  >{{ xItem }}
                </div>
              </div>
            </div>
            <div v-else-if="curTopicInfo.type == 7" style="margin: 20px 0">
              <span style="margin-right: 10px"
                >{{ curTopicInfo.yes }} {{ curTopicInfo.no }}</span
              >{{ answerItem }}
            </div>
            <div
              v-else-if="curTopicInfo.type == 9"
              style="margin: 20px 0; display: flex"
            >
              <span
                :style="{ opacity: index == 0 ? 0 : 1 }"
                style="margin-right: 20px"
              >
                {{ english[index - 1] ? english[index - 1] : "A" }}
              </span>
              <span
                style="margin-right: 20px"
                :style="{ opacity: index == 0 ? 0 : 1 }"
              >
                {{ curTopicInfo.yes }} {{ curTopicInfo.no }}</span
              >
              <div
                style="width: 300px"
                v-html="answerItem[0].replace(/\n/g, '<br>')"
              ></div>
              <div
                style="width: 300px"
                v-html="answerItem[1].replace(/\n/g, '<br>')"
              ></div>
            </div>
            <div v-else-if="curTopicInfo.type == 6">
              <div>
                {{ answerItem.title }}________ {{ answerItem.title2 }}
                {{ answerItem.title3 ? "________" : "" }}
                {{ answerItem.title3 }}

                <div style="margin: 20px 0">
                  选择项：
                  <span
                    v-for="(item, i) in answerItem.option"
                    :key="i"
                    style="margin-right: 20px"
                  >
                    {{ item }}
                  </span>
                </div>
                <div v-if="answerItem.option2.length != 0" class="mb20">
                  选择项：
                  <span
                    v-for="(item, i) in answerItem.option2"
                    :key="i"
                    style="margin-right: 20px"
                  >
                    {{ item }}
                  </span>
                </div>
              </div>
            </div>
            <div v-else-if="curTopicInfo.type == 3">
              <div
                v-if="index == 0"
                class="mb20"
                style="display: flex; align-items: center"
              >
                <div style="width: 50px"></div>
                <div style="width: 150px" v-html="curTopicInfo.yes"></div>
                <div style="width: 150px" v-html="curTopicInfo.no"></div>
                <div style="width: calc(100% - 350px)"></div>
              </div>
              <div style="display: flex; align-items: center">
                <div style="width: 50px">{{ english[index] }}</div>
                <div style="width: 150px"></div>
                <div style="width: 150px"></div>
                <div
                  v-html="answerItem"
                  style="width: calc(100% - 350px)"
                ></div>
              </div>
            </div>
            <div v-else v-html="answerItem"></div>
          </div>
        </div>
        <div class="my_answer mb20 flex">
          <div>我的答案：</div>
          <div v-if="curTopicInfo.type === 1">
            <span v-for="(item, index) in curTopicInfo.myanswer" :key="index">
              <div
                v-if="curTopicInfo.answer[item]"
                v-html="curTopicInfo.answer[item].replace(/\n/g, '<br>')"
              ></div>
            </span>
          </div>
          <div v-else-if="curTopicInfo.type === 2">
            <span v-for="(item, index) in curTopicInfo.myanswer" :key="index">
              <span v-for="(item2, index2) in item" :key="index2">
                <div
                  v-if="
                    curTopicInfo.answer[index] &&
                    curTopicInfo.answer[index][item2]
                  "
                  v-html="
                    curTopicInfo.answer[index][item2].replace(/\n/g, '<br>')
                  "
                ></div> </span
              ><br
            /></span>
          </div>
          <div v-else-if="curTopicInfo.type === 3 || curTopicInfo.type === 4">
            <div>
              <span style="margin-right: 10px">{{ curTopicInfo.yes }}:</span>
              <span
                v-for="(item, index) in curTopicInfo.myanswer"
                :key="index"
                v-if="parseInt(item) % 2 === 0"
              >
                <div
                  v-if="curTopicInfo.answer[parseInt(item / 2)]"
                  v-html="
                    curTopicInfo.answer[parseInt(item / 2)].replace(
                      /\n/g,
                      '<br>'
                    )
                  "
                ></div> </span
              ><br />
            </div>
            <div>
              <span style="margin-right: 10px">{{ curTopicInfo.no }}:</span>
              <span
                v-for="(item, index) in curTopicInfo.myanswer"
                :key="index"
                v-if="parseInt(item) % 2 === 1"
              >
                <div
                  v-if="curTopicInfo.answer[parseInt(item / 2)]"
                  v-html="
                    curTopicInfo.answer[parseInt(item / 2)].replace(
                      /\n/g,
                      '<br>'
                    )
                  "
                ></div> </span
              ><br />
            </div>
          </div>
          <div
            v-else-if="curTopicInfo.type === 5"
            v-html="curTopicInfo.myanswer[0].replace(/\n/g, '<br>')"
          ></div>

          <div v-else-if="curTopicInfo.type === 7">
            <div v-for="(z, i) in curTopicInfo.myanswer" :key="i">
              {{ z % 2 == 0 ? curTopicInfo.yes : curTopicInfo.no }}
            </div>
          </div>
          <div v-else-if="curTopicInfo.type === 9">
            <div v-for="(z, i) in curTopicInfo.myanswer" :key="i">
              {{
                z % 2 == 0
                  ? english[i] + " " + curTopicInfo.yes
                  : english[i] + " " + curTopicInfo.no
              }}
            </div>
          </div>
          <div v-else-if="curTopicInfo.type === 8">
            <div v-for="(z, i) in curTopicInfo.myanswer" :key="i">
              <div v-if="z.length != 0">
                <!-- {{ i == 0 ? "判断题：" : "单选题：" }} -->
                <div v-for="y in z">
                  <div v-if="i == 0">
                    {{ y % 2 == 0 ? curTopicInfo.yes : curTopicInfo.no }}
                  </div>
                  <div v-else>
                    {{
                      curTopicInfo.opt[i][y * 1]
                        ? curTopicInfo.opt[i][y * 1] + ". "
                        : ""
                    }}{{ curTopicInfo.answer[i][y * 1] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="curTopicInfo.type === 6">
            <div v-for="(z, i) in curTopicInfo.myanswer" :key="i">
              <span style="margin-right: 20px">
                {{ z[0] }}
              </span>
              <span v-if="z[1]">
                {{ z[1] }}
              </span>
            </div>
          </div>
        </div>
        <div class="correct_answer mb20 flex">
          <div>正确答案：</div>
          <div v-if="curTopicInfo.type === 1">
            <span v-for="(item, index) in curTopicInfo.ranswer" :key="index">
              <div
                v-if="curTopicInfo.answer[item]"
                v-html="curTopicInfo.answer[item].replace(/\n/g, '<br>')"
              ></div>
            </span>
          </div>
          <div v-else-if="curTopicInfo.type === 2">
            <span v-for="(item, index) in curTopicInfo.ranswer" :key="index">
              <span v-for="(item2, index2) in item" :key="index2">
                <div
                  v-if="
                    curTopicInfo.answer[index] &&
                    curTopicInfo.answer[index][item2]
                  "
                  v-html="
                    curTopicInfo.answer[index][item2].replace(/\n/g, '<br>')
                  "
                ></div>
              </span>
              <br />
            </span>
          </div>
          <div v-else-if="curTopicInfo.type === 6">
            <div v-for="(z, i) in curTopicInfo.ranswer" :key="i">
              <span style="margin-right: 20px">
                {{ z[0] }}
              </span>
              <span v-if="z[1]">
                {{ z[1] }}
              </span>
            </div>
          </div>
          <div v-else-if="curTopicInfo.type === 7">
            <div v-for="(z, i) in curTopicInfo.ranswer" :key="i">
              {{ z % 2 == 0 ? curTopicInfo.yes : curTopicInfo.no }}
            </div>
          </div>
          <div v-else-if="curTopicInfo.type === 9">
            <div v-for="(z, i) in curTopicInfo.ranswer" :key="i">
              {{
                z % 2 == 0
                  ? english[i] + " " + curTopicInfo.yes
                  : english[i] + " " + curTopicInfo.no
              }}
            </div>
          </div>
          <div v-else-if="curTopicInfo.type === 8">
            <div v-for="(z, i) in curTopicInfo.ranswer" :key="i">
              <div v-if="z.length != 0">
                <!-- {{ i == 0 ? "判断题：" : "单选题：" }} -->

                <div v-for="y in z">
                  <div v-if="i == 0">
                    {{ y % 2 == 0 ? curTopicInfo.yes : curTopicInfo.no }}
                  </div>
                  <div v-else>
                    {{
                      curTopicInfo.opt[i][y * 1]
                        ? curTopicInfo.opt[i][y * 1] + ". "
                        : ""
                    }}{{ curTopicInfo.answer[i][y * 1] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="curTopicInfo.type === 3 || curTopicInfo.type === 4">
            <div>
              <span style="margin-right: 10px">{{ curTopicInfo.yes }}:</span>
              <span
                v-for="(item, index) in curTopicInfo.ranswer"
                :key="index"
                v-if="parseInt(item) % 2 === 0"
              >
                <div
                  v-if="curTopicInfo.answer[parseInt(item / 2)]"
                  v-html="
                    curTopicInfo.answer[parseInt(item / 2)].replace(
                      /\n/g,
                      '<br>'
                    )
                  "
                ></div> </span
              ><br />
            </div>
            <div>
              <span style="margin-right: 10px">{{ curTopicInfo.no }}:</span>
              <span
                v-for="(item, index) in curTopicInfo.ranswer"
                :key="index"
                v-if="parseInt(item) % 2 === 1"
              >
                <div
                  v-if="curTopicInfo.answer[parseInt(item / 2)]"
                  v-html="
                    curTopicInfo.answer[parseInt(item / 2)].replace(
                      /\n/g,
                      '<br>'
                    )
                  "
                ></div> </span
              ><br />
            </div>
          </div>
        </div>
        <!-- <div class="topic_info">
          <span>{{ curTopicInfo.peoplenum }}人做过此题</span>
          <span>我的耗时{{ curTopicInfo.myusetime | formatTime }}</span>
          <span>平均耗时为{{ curTopicInfo.aveusetime | formatTime }}</span>
          <span>平均正确率为{{ curTopicInfo.average }}%</span>
        </div> -->
      </div>

      <h2 style="margin-top: 20px">解析</h2>
      <div
        class="titleInfo analysisNote"
        v-if="curTopicInfo"
        v-html="curTopicInfo.analysis"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import headers from "../../components/header.vue";
import api from "@/api/dryRun.js";
import personal from "@/api/personallnfo.js";
import table from "../examinatSystem/table.vue";
export default {
  components: {
    headers,
  },
  mounted() {
    this.$refs.headers.headerBack = {
      backgroundColor: "#fff",
    };
    this.$refs.headers.herderTit = {
      color: "rgb(102,102,102)",
    };
    this.$refs.headers.headerIcon = require("@/assets/home/headerNav.png");
    console.log(this.$refs.headers.headerIcon);
    // this.$refs.header.isTop=false;
    // this.$refs.header.headerBack.background = '#ffffff';
    // this.$refs.header.herderTits.color = '#666666';
    // this.$refs.header.headerIcon = require('@/assets/home/headerNav.png');
    // this.$refs.header.loginButton = {
    //     background : '#618aff',
    //     color:'#fff'
    // }
    // this.$refs.header.phoneButton = {
    // color:'#618aff',
    // border: '1px solid #618aff'
    //   }
    // api.baseParams().then(res => {
    //   console.log(res)
    // })
  },
  data() {
    return {
      curTabIndex: 0,
      curTopicIndex: 0,
      navCodes: require("@/assets/login/navCode.png"),
      headerIcon: require("@/assets/home/headerNav.png"),
      herderTits: {
        color: "#000",
      },
      table: [],
      tableData: [],
      status: false,
      headerBack: {
        background: "#ffffff",
      },
      addText: false,
      mockResult: null, //考试结果数据
      curTopicParams: {
        m_id: sessionStorage.getItem("m_id"),
        q_id: 0,
        id: sessionStorage.getItem("curId"),
      },
      curTopicInfo: null, //当前题目信息
      choosed: 0,
      reasoningList: [],
      bottomTableList: [],
      english: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  created() {
    this.getMockResult().then(() => {
      console.log(this.mockResult, "111111");
      this.curTopicParams.q_id = this.mockResult.topics[0]
        ? this.mockResult.topics[0].topics[0].id
        : 0;
      this.getProblemAnalysis();
    });
  },
  mounted() {
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
    // api.baseParams().then(res => {
    //   console.log(res)
    // })
  },
  filters: {
    formatTime(time) {
      return `${Math.floor(time / 60)}min${time % 60}s`;
    },
  },
  methods: {
    // 获取模考题目解析
    async getProblemAnalysis() {
      const loadingObj = this.$loading({
        target: document.querySelector(".analysis"),
        lock: true,
        text: "拼命加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const res = await api.getProblemAnalysis(this.curTopicParams);
      if (res.data.code === 0) {
        console.log("考题解析", res);
        this.curTopicInfo = res.data.data;
        if (this.curTopicInfo.type == 7) {
          this.getTable();
        } else if (this.curTopicInfo.type == 8) {
          this.getReasoningList();
        }
      }
      loadingObj.close();
    },
    getReasoningList() {
      this.reasoningList = [];
      this.choosed = "0";
      this.$nextTick(() => {
        const nameList = [];
        this.curTopicInfo.reasoningList.forEach((item) => {
          if (!nameList.includes(item.reasoning_title)) {
            nameList.push(item.reasoning_title);
            this.reasoningList.push(item);
          }
        });
        for (const item of this.curTopicInfo.getReasoningList) {
          if (!nameList.includes(item.name)) {
            nameList.push(item.name);
            this.reasoningList.push({
              reasoning_title: item.name,
              reasoning_content: item.content,
            });
          }
        }
      });
    },
    getSummaries() {
      return this.bottomTableList;
    },
    getTable() {
      if (this.curTopicInfo.table_status == 1) {
        this.bottomTableList =
          this.curTopicInfo.table_list[this.curTopicInfo.table_list.length - 1];
        this.curTopicInfo.table_list.pop();
      }
      let name = [];
      this.tableList = [];
      this.table = [];
      let indexList = [];
      let list = [];
      this.status = false;
      this.$nextTick(() => {
        this.curTopicInfo.table_list[0].forEach((item) => {
          if (item) {
            this.status = true;
          }
        });
        if (this.status) {
          let num = [];
          this.curTopicInfo.table_list[0].forEach((item, index) => {
            if (item == "" && this.curTopicInfo.table_list[1][index] != "") {
              this.tableList.push({
                index,
                value: this.curTopicInfo.table_list[1][index],
                list: [],
              });
            } else {
              let ressult = false;
              this.curTopicInfo.table_list[0].forEach((z, i) => {
                if (item != "" && z != "" && item == z && i != index) {
                  console.log(z, item, index, i);
                  ressult = true;
                  if (num.length == 0) {
                    num.push({
                      value: item,
                      length: this.tableList.length,
                      list: [index],
                    });
                    this.tableList.push({
                      index: index,
                      value: item,
                      list: [
                        {
                          index: index,
                          value: this.curTopicInfo.table_list[1][index],
                        },
                      ],
                    });
                  } else {
                    let xRes = false;
                    let xRes1 = false;
                    num.forEach((res) => {
                      if (res.value == item) {
                        let result = false;
                        for (let x = 0; x < res.list.length; x++) {
                          if (res.list[x] == index) {
                            result = true;
                          }
                        }
                        if (!result) {
                          this.tableList[res.length].list.push({
                            index: index,
                            value: this.curTopicInfo.table_list[1][index],
                          });
                          res.list.push(index);
                        }
                        xRes1 = true;
                        xRes = false;
                      } else {
                        if (!xRes1) {
                          xRes = true;
                        }
                      }
                    });
                    if (xRes) {
                      num.push({
                        value: item,
                        length: this.tableList.length,
                        list: [index],
                      });
                      this.tableList.push({
                        index: index,
                        value: item,
                        list: [
                          {
                            index: index,
                            value: this.curTopicInfo.table_list[1][index],
                          },
                        ],
                      });
                    }
                  }
                }
              });
              if (!ressult) {
                this.tableList.push({
                  index: index,
                  value: item,
                  list: [
                    {
                      index: index,
                      value: this.curTopicInfo.table_list[1][index],
                    },
                  ],
                });
              }
            }
          });
          this.curTopicInfo.table_list.forEach((element, index) => {
            if (index != 0 && index != 1) {
              this.table.push({});
              element.forEach((item, idx) => {
                this.table[index - 2][`name${idx}`] = item === '' ? item : isNaN(item * 1)
                  ? item
                  : item * 1;
              });
            }
          });
          return;
        }
        this.curTopicInfo.table_list.forEach((element, index) => {
          if (index != 0 && index != 1) {
            this.table.push({});
          }
          element.forEach((item, idx) => {
            if (index == 0) {
              if (item || idx === 0) {
                this.tableList.push({
                  index: item,
                  list: [],
                });
              }
              indexList.push(this.tableList.length - 1);
            } else if (index == 1) {
              this.tableList[indexList[idx]].list.push(item);
              let i =
                indexList[idx] +
                "-" +
                (this.tableList[indexList[idx]].list.length - 1);
              name.push(i);
            } else {
              this.table[index - 2][name[idx]] = item === '' ? item : isNaN(item * 1)
                ? item
                : item * 1;
            }
          });
        });
      });
    },
    // 获取模考结果
    async getMockResult() {
      let params = {
        m_id: sessionStorage.getItem("m_id"),
        id: sessionStorage.getItem("curId"),
      };
      const res = await api.getMockResult(params);
      if (res.data.code === 0) {
        console.log("模考结果", res);
        this.mockResult = res.data.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // tab的切换
    switchTab(index) {
      this.curTabIndex = index;
      this.curTopicIndex = 0;
      this.curTopicParams.q_id =
        this.mockResult.topics[this.curTabIndex].topics[this.curTopicIndex].id;
      this.getProblemAnalysis();
    },
    // 切换题目查看解析
    switchTopic(item, index) {
      this.curTopicIndex = index;
      this.curTopicParams.q_id = item.id;
      this.curTopicParams.q_id =
        this.mockResult.topics[this.curTabIndex].topics[this.curTopicIndex].id;
      this.getProblemAnalysis();
    },
    //显示增加笔记
    showAddText() {
      this.addText = true;
    },
    //笔记确定
    defineText() {
      this.cancelText();
    },
    //笔记取消
    cancelText() {
      this.addText = false;
    },
  },
};
</script>

<style scoped>
@import url("../../assets/css/scheduleMatter.css");

/* .herderNav {
  background-color: #000;
} */
.header.herderTits {
  color: "rgb(102,102,102)";
}

.switchTab li.active {
  border-bottom: 1px #4c91ff solid;
}

.topic_list {
  display: flex;
  padding-bottom: 15px;
  border-bottom: 1px solid #dedede;
  margin-bottom: 15px;
}

.topic_item {
  width: 44px;
  height: 36px;
  background-color: #fff;
  border: 2px solid #dedede;
  line-height: 36px;
  text-align: center;
  margin: 12px 12px 0 0;
  cursor: pointer;
  color: #333;
}

.topic_item.correct.active {
  background-color: #62cd62;
  border: none;
  color: #ffffff;
}

.topic_item.error.active {
  background-color: #fa7070;
  border: none;
  color: #ffffff;
}

.topic_item.correct {
  border-bottom: 4px solid #62cd62;
}

.topic_item.correct:hover {
  background-color: #62cd62;
  border: none;
  color: #ffffff;
}

.topic_item.error {
  border-bottom: 4px solid #fa7070;
}

.topic_item.error:hover {
  background-color: #fa7070;
  border: none;
  color: #ffffff;
}

.mb20 {
  margin-bottom: 20px;
}

.topic_info span {
  font-size: 12px;
  color: #999;
  margin-right: 15px;
}

.flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/view/questionBank/scheduleMatter.vue